<template>
  <v-sheet>
    <v-dialog
      v-model="promptDeleteHome"
      max-width="450"
    >
      <home-delete />
    </v-dialog>
  </v-sheet>
</template>

<script>
import HomeMixin from 'src/home/store/utils/home-mixin'

export default {
  name: 'HomeModals',
  components: {
    HomeDelete: () => import('src/home/components/HomeDelete'),
  },
  mixins: [
    HomeMixin,
  ],
}
</script>
